import { identity } from 'lodash'
import { StepType } from '@feedyou/schema'

import { reducer as aiReducer } from './Ai/slice'
import { reducer as noteReducer } from './Note/slice'
import { emailReducer } from './Email/reducer'
import { actionReducer } from './Action/reducer'
import { reducer as promptReducer } from './Prompt/slice'
import { dialogReducer } from './Dialog/reducer'
import { switchReducer } from './Switch/reducer'
import { messageReducer } from './Message/reducer'
import { timeoutReducer } from './Timeout/reducer'
import { storageReducer } from './Storage/reducer'
import { reducer as questionReducer } from './Question/slice'
import { postponeReducer } from './Postpone/reducer'
import { attachmentReducer } from './Attachment/reducer'

const stepReducers = {
  ai: aiReducer,
  note: noteReducer,
  email: emailReducer,
  prompt: promptReducer,
  dialog: dialogReducer,
  action: actionReducer,
  switch: switchReducer,
  storage: storageReducer,
  timeout: timeoutReducer,
  message: messageReducer,
  question: questionReducer,
  postpone: postponeReducer,
  attachment: attachmentReducer
} as const

export function getStepReducerByType(type: StepType) {
  // @ts-ignore
  return stepReducers[type] || identity
}
